function updateOptions(options) {
    const update = { ...options };
    if (localStorage["auth-m3t"]) {
        var auth = JSON.parse(localStorage["auth-m3t"])
        update.headers = {
            ...update.headers,
            Authorization: `Bearer ${auth.token}`,
        };
    }
    return update;
}

export default function fetcher(url, options) {
    // return fetch(url, updateOptions(options));
    return new Promise((resolve, reject) => {
        fetch(url, updateOptions(options)).then(response => {
            // response only can be ok in range of 2XX
            if (response.ok) {
                // you can call response.json() here too if you want to return json
                resolve(response);
            } else {
                //handle errors in the way you want to
                switch (response.status) {
                    case 404:
                        console.log('Object not found');
                        break;
                    case 500:
                        console.log('Internal server error');
                        break;
                    case 401:
                        console.log('Not Autorized');
                        localStorage.setItem("auth-m3t", JSON.stringify({token: null, username: "guest", role: "guest"}));
                        if (!window.location.pathname.endsWith("/login")) {
                            window.location = "/login"
                        }
                        break;
                    default:
                        console.log('Some error occured');
                        break;
                }
                console.log(response);
                //here you also can thorow custom error too
                reject(response);
            }
        })
        .catch(error => {
            //it will be invoked mostly for network errors
            //do what ever you want to do with error here
            console.log(error);
            reject(error);
        });
    });

}
